// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Interne Module
import { getDate, getParticipants, tripStartCountdown } from '@/_helper/bookingDetailsHelper';
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';

// Komponenten
import { BackButton } from '@/comp/backButton/backButton';

// Styles
import './excursion.scss';

class Excursion extends Component {
    constructor(props) {
        super(props);
        this.Card = this.Card.bind(this);

        this.state = {
            bookingData: this.props.bookingData,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.pageState === 'loading' && this.props.pageState === 'loaded') {
            this.enrichExcursionData();
        }
    }

    componentDidMount() {
        if (this.props.cancellationData !== null) {
            this.enrichExcursionData();
        }
    }

    enrichExcursionData() {
        const bookingData = this.state.bookingData;
        const excursions = bookingData.data?.frontendParams?.excursions;

        let cancellationData = this.props.cancellationData?.excursion ?? storage.get('cancellationData').excursion;

        if (excursions !== undefined && cancellationData !== undefined) {
            excursions.forEach((item) => {
                if (item && item.state !== 'XX') {
                    const additionalData = cancellationData[item.bookingId];

                    item.cancellationAllowed = additionalData?.cancellationAllowed ?? undefined;
                    item.cancellationCurrency = additionalData?.cancellationCurrency ?? undefined;
                    item.currentCancellationPrice = additionalData?.currentCancellationPrice ?? undefined;
                    item.nextCancellationDate = additionalData?.nextCancellationDate ?? undefined;
                    item.nextCancellationPrice = additionalData?.nextCancellationPrice ?? undefined;
                }
            });
        }

        bookingData.data.frontendParams.excursions = excursions;
        storage.set('bookingData', bookingData);

        this.setState({ bookingData: bookingData });
    }

    Card(props) {
        const { index, item } = props;

        // check if excursion is still to happen
        let isActive = tripStartCountdown(item.startDate);

        if (isActive !== false) {
            isActive = isActive >= 0;
        }

        let cardState = isActive ? 'active' : 'disabled';
        let buttonText = isActive ? 'Diesen Ausflug stornieren' : 'Der Ausflug hat stattgefunden';

        if (item.state === 'XX') {
            cardState = 'cancelled';
            buttonText = 'Dieser Ausflug wurde storniert';
        }

        const title = item.title ?? item.description.split(' -')[0];

        if (this.props.pageState !== 'loading') {
            return (
                <section className={`card ${cardState}`}>
                    <div className="card-header">
                        <i className="material-symbols-outlined">attractions</i>
                        <h3>Ausflug "{title}"</h3>
                    </div>
                    <div className="card-body">
                        <div className="card-content">
                            <Link
                                to={`/leistung-stornieren/ausflug/uebersicht/${index}`}
                                onClick={() => {
                                    tracking('interaction', 'partialCancellationExcursion');
                                }}>
                                <div className={`image-sec${item.image === undefined ? ' no-image' : ''}`}>
                                    {item.image !== undefined && (
                                        <LazyLoadImage
                                            wrapperClassName="lazy-load-background"
                                            src={item.image}
                                            alt={`Bild des Ausflugs "${title}"`}
                                            effect="blur"
                                        />
                                    )}
                                </div>
                            </Link>
                            <div className="card-info">
                                <div className="item-date">
                                    <h3>Ausflugsdatum</h3>
                                    <div>{getDate(item)}</div>
                                </div>
                                <div className="item-participants">
                                    <h3>Teilnehmende</h3>
                                    <div>{getParticipants(item)}</div>
                                </div>
                            </div>
                        </div>
                        <Link
                            to={`/leistung-stornieren/ausflug/uebersicht/${index}`}
                            disabled={cardState !== 'active'}
                            className={`button ${cardState}`}
                            onClick={() => {
                                tracking('interaction', 'partialCancellationExcursion');
                            }}>
                            {buttonText}
                        </Link>
                    </div>
                </section>
            );
        } else {
            return (
                <section className="card loading lazy-load-background">
                    <span className="card-header"></span>
                    <div className="card-body">
                        <div className="card-content">
                            <span className="image-sec"></span>
                            <div className="card-info">
                                <div className="item">
                                    <span className="item-header"></span>
                                    <span className="item-content"></span>
                                </div>
                            </div>
                        </div>
                        <span className="button"></span>
                    </div>
                </section>
            );
        }
    }

    render() {
        const data = this.props.bookingData?.data;
        const excursions = data.frontendParams.excursions;

        if (excursions !== undefined) {
            return (
                <div className="content-wrapper">
                    <h1 className="main-headline">Ausflug stornieren</h1>
                    <div className="subline">Bitte wählen Sie den Ausflug aus, den Sie stornieren möchten.</div>
                    <div className="content">
                        {excursions.map((item, index) => {
                            return <this.Card key={index} index={index} item={item} />;
                        })}
                    </div>

                    <div className="user-action flex-center">
                        <BackButton class="button" to="/buchungsuebersicht" />
                    </div>
                </div>
            );
        }
    }
}

export default Excursion;
